export const ASSIGNMENT_QUERY_PARAMETER_TAB: string = "tab";
export const ASSIGNMENT_QUERY_PARAMETER_MODULEID: string = "moduleId";
export const ASSIGNMENT_QUERY_PARAMETER_BADGEID: string = "badgeId";
export const ASSIGNMENT_QUERY_PARAMETER_WORKITEMID: string = "workItemId";

export const ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_STUDENT_SUBMIT: string = "submit";
export const ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_EVALUATOR_REVIEW: string = "review";
export const ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_JOURNAL: string = "journal";
export const ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_GROUP: string = "group";
export const ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_CALENDAR: string = "calendar";
